// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // dev cluster: same hostname for all APIs, distinct port per API via tls-proxy
  // (mirrors prod pattern api.breadlab.hn:PORT). See INF-022 + INF-026.
  // - 3006 -> dev-api-clients (datacenter firewall blocks 3012 inbound, 3006 is the bypass)
  // - 3011 -> dev-api-sms
  api : 'https://dev-api.breadlab.hn:3006/api/',
  apisms : 'https://dev-api.breadlab.hn:3011/api/',
  // PixelPay sandbox (A-546): setupSandbox() trae sus propias credenciales,
  // por eso keyId/secretKeyHash van vacios — las llaves live NO deben viajar
  // en el bundle de dev. pixelpaySandboxCase = monto que selecciona el caso
  // de prueba del sandbox (1=aprobada, 2=declinada, ... 14).
  pixelpaySandbox: true,
  pixelpaySandboxCase: 1,
  keyId: '',
  secretKeyHash: '',
  // Llave AES solo para cifrar la tarjeta en el storage local del navegador
  // (antes se reutilizaba secretKeyHash). Valor distinto al de prod a proposito.
  localCryptoKey: 'bl-dev-local-storage-aes-a546',
  endPointPixelPay: 'https://hn.ficoposonline.com',
  ga: 'G-DWWYGFPK7M',
  apiaws: 'https://3zmwknl9v1.execute-api.us-west-2.amazonaws.com/',
  pathImages: 'https://storage.googleapis.com/breadlab-d9d47.firebasestorage.app/app'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
